import { useEffect } from "react";

import { useFeatureFlagGlobalStore } from "../use-feature-flag-global-store";

import { useFeatureFlagList } from "./use-feature-flag-list";

interface UseFeatureFlagPreloaderProps {
  workspaceId: string;
}

export const useFeatureFlagPreloader = ({ workspaceId }: UseFeatureFlagPreloaderProps) => {
  const { featureFlagList, loading, error } = useFeatureFlagList({
    workspaceId,
  });

  const setServerFeatureFlags = useFeatureFlagGlobalStore((state) => state.setServerFeatureFlags);
  const setLoading = useFeatureFlagGlobalStore((state) => state.setLoading);

  useEffect(() => {
    if (featureFlagList.length > 0) {
      setServerFeatureFlags(featureFlagList);
    }
  }, [featureFlagList, setServerFeatureFlags]);

  useEffect(() => {
    setLoading(loading);
  }, [loading, setLoading]);

  return {
    loading,
    error,
  };
};
